// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Operation {}

export class DefaultOperation implements Operation {}
